import React, { useRef, useCallback } from "react";
import { Form, Row, Col, Select } from "antd";

/**
 * 角色列表筛选。名称和描述走快捷搜索，这里按「已分配的权限」缩小范围。
 */
const RoleListFilter = ({ onSearch, permissions = [], autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        form.validateFields().then((values) => {
            onSearch(values);
        });
    }, [form, onSearch]);

    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 300);
    }, [autoApply, handleSearch]);

    return (
        <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
            <Row gutter={24}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="permission_id" label="包含权限" extra="只保留已经分配了该权限的角色">
                        <Select
                            allowClear
                            showSearch
                            placeholder="全部权限"
                            optionFilterProp="label"
                            options={permissions.map((permission) => ({
                                value: permission.id,
                                label: permission.description ? `${permission.name}（${permission.description}）` : permission.name,
                            }))}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default RoleListFilter;
